import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { DataVehiculosService } from "../../gestion-vehiculos/services/data-vehiculos.service";


@Component({
    selector: 'app-modal-vehicle',
    templateUrl: './modal-vehicle.component.html',
    styleUrls: ['./modal-vehicle.component.scss']
})


export class ModalVehicleComponent implements OnInit {
    @Output() closeModalVehicle = new EventEmitter<any>();
    transmitter: string;
    botonGuardar: Subscription;
    botonCancelar: Subscription;
    constructor(private _dataVehiculosService: DataVehiculosService) {
        this.transmitter = 'gestionTerceros';
    }

    ngOnInit() {
        this.botonGuardar = this._dataVehiculosService.observerBotonGuardar().subscribe(val => {
            if (val === true) {
                this.closeModalVehicle.emit(true);
            }
        });
        this.botonCancelar = this._dataVehiculosService.observerBotonCancelar().subscribe(val => {
            if (val === true) {
                this.closeModalVehicle.emit(false);
            }
        });
    }
    modalClosePopup() {
        this.closeModalVehicle.emit(false);
    }




}



